import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VModal from 'vue-js-modal';
Vue.use(VModal);

import {VueHammer} from 'vue2-hammer';
Vue.use(VueHammer);

import Notifications from 'vue-notification';
Vue.use(Notifications);

// Axios
import axios from 'axios';

import './assets/tailwind.css'

axios.defaults.baseURL = process.env.VUE_APP_API;
axios.defaults.headers.post["Content-Type"] = "application/json";
Vue.prototype.$http = axios;

axios.interceptors.request.use(function (config) {
  const authToken = window.localStorage.getItem('pobr-auth');

  if (authToken) {
    config.headers['Authorization'] = `Bearer ${authToken}`;
  }

  config.headers['pobr-session'] = window.localStorage.getItem('pobr-session');

  return config;
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
